import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import MasterLayout from '../../../masterLayout/MasterLayout';
import Breadcrumb from '../../../components/Breadcrumb';
import { AppButton } from '../../../components/ui';
import { ROUTES } from '../../../config/routes';

const ADMIN_SECTIONS = [
  {
    title: 'Template pipeline',
    description: 'Étapes, libellés, responsables par défaut et statuts initiaux pour les nouveaux adhérents',
    icon: 'mdi:pipeline',
    color: 'primary',
    to: ROUTES.klub.adminPipeline,
  },
];

const KlubAdminHubPage = () => (
  <MasterLayout>
    <Breadcrumb
      title="Administration Klub"
      hideHeading
      actions={(
        <AppButton
          as={Link}
          to={ROUTES.klub.dashboard}
          size="sm"
          variant="outline-secondary"
          icon="mdi:arrow-left"
        >
          Retour
        </AppButton>
      )}
    />

    <div className="mb-24">
      <h4 className="fw-semibold mb-1">Administration Klub</h4>
      <p className="text-secondary-light mb-0">
        Configuration du module Communauté Klub
      </p>
    </div>

    <div className="row g-3">
      {ADMIN_SECTIONS.map((section) => (
        <div className="col-md-6 col-xl-4" key={section.title}>
          <Link to={section.to} className="text-decoration-none">
            <div className={`card h-100 border-0 shadow-sm hover-shadow transition`}>
              <div className="card-body p-24">
                <div className={`w-48-px h-48-px bg-${section.color}-50 text-${section.color}-600 rounded-circle d-flex align-items-center justify-content-center mb-16`}>
                  <Icon icon={section.icon} className="text-2xl" />
                </div>
                <h6 className="fw-semibold mb-8 text-dark">{section.title}</h6>
                <p className="text-secondary-light text-sm mb-0">{section.description}</p>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  </MasterLayout>
);

export default KlubAdminHubPage;
